import { HEADER_HEIGHT } from '@zen/Layout';

const SCROLL_GAP: number = 10;

export const getContainerScrollTop = (element: Element, container: Element, additionalYOffset: number): number =>
  element.getBoundingClientRect().top -
  container.getBoundingClientRect().top +
  container.scrollTop -
  SCROLL_GAP -
  additionalYOffset;

export const getWindowScrollTop = (element: Element, additionalYOffset: number): number =>
  element.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT - SCROLL_GAP - additionalYOffset;
